//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 const baseURL = pageInfo.site_url+"/wp-json/wp/v2/";

 import axios from 'axios'
 import OperatorMap from './OperatorMap.vue'
 import { EventBus } from './event-bus'; // not really used atm, we're emitting events from this app, but no othercompoenents are listening for them (previously listened for by deleted overlay component)
 import ArticleListItem from "./ArticleListItem.vue";
 import SearchFilter from "./SearchFilter.vue";
 import iconListView from "./svg/svgList.vue";
 import iconMapView from "./svg/svgMap.vue";
 import BtnFavourites from './ButtonFavourites.vue'
 import mixins from './utilities.js'
 import pagination from './alphaPagination.js'
 import infiniteScroll from './infiniteScroll'

 export default {
   name: 'Operators',
   props: {},
   mixins: [mixins, pagination, infiniteScroll],
   components: {
     OperatorMap,
     ArticleListItem,
     SearchFilter,
     iconListView,
     iconMapView,
     BtnFavourites,
   },
   data: function () {
     return {
       displayAdvanced: true,
       locations: [],
       allCategories: [],
       allCategoriesString: '',
       categories: [],
       facilities: [],
       selectedFacility: '',
       selectedCategory: '',
       selectedLocation: '',
       selectedSubCategories: [],
       selectedPaginationItem: false,
       operators: [],
       keywords: '',
       itemsPerPage: 9,
       pageNumber: 1,
       postType: '',
       operatorLength: 0,
       pagesTotal: 0,
       noResults: false,
       isLoading: false,
       restParamsString: '',
       queryString: '',
       isMapView: false,
       selectedCategoryHeading: '',
       operatorListingType: null,
       operator_category: '',
       mapOperators: [],
       filterData: { keywords: "", category: "", dateRange: [] }, //store data entered in filter before user presses submit, for when we dont want our list to auto filter
       paginationItems: 'operators', // variable name of items you are paginating
       wisdom_operatorfeedblock: null
     }
   },
   // watch: {
   //   hasMorePages() {
   //     if(!this.hasMorePages)
   //       this.removeInfiniteListener();
   //   },
   // },
   mounted: function () {

console.warn("feed COMP MOUNTED");
   //  let self = this

   //   // Get all categories
   //   this.categories = window.atdwCategories
   //   window.atdwCategories.forEach(function (parentCategories) {
   //     parentCategories.categories.forEach(function (atdwCategory) {
   //       self.allCategoriesString += '&all_categories[]=' + atdwCategory
   //     })
   //   })
   //   // If $_GET['category'] is set, select it from dropdown
   //   if (window.category) {
   //     this.selectedCategory = window.category[0]
   //   }

   //   this.locations = window.atdwLocations

     this.getLocations();
     this.getCategories();
     this.getFacilities();

     //this.getOperators();

   },
   created: function () {

     this.getPostsRequest = this.makeAJAXRequest();
     this.debounceKeywords = this.delay();

     //this.operatorListingType = pageInfo.operator_category.slug;

     this.operator_category = pageInfo.operator_category;
     this.operatorListingType = pageInfo.operator_listing_type;

     //this.operator_listing_type = pageInfo.operator_listing_type;
     //this.filterHeading = this.operator_category.name

     //   this.selectedCategory = $category;

     this.postType  = 'operator';


     if(typeof wisdom_operatorfeedblock !== 'undefined' ) {
       // leave line below to revent es lint no-undef warning
       /* global wisdom_operatorfeedblock */
       this.wisdom_operatorfeedblock = wisdom_operatorfeedblock.id;
     }

     else if(pageInfo.listing_post_type)
       this.postType = pageInfo.listing_post_type;
     else if (pageInfo.operator_listing_type.slug != 'see-do') //'wp-operators'
       this.postType = 'members';


   //   if(this.postType == 'deal')
   //     this.selectedCategory = []; //change to array type

     if(this.wisdom_operatorfeedblock) {
       if(typeof pageInfo.operator_category !== 'undefined' ) {
         pageInfo.operator_category.forEach(cat => {
           if(cat.parent == 0) {
             this.selectedCategory = cat.term_id
           } else {
             this.selectedCategory = cat.parent;
             this.selectedSubCategories.push(cat.term_id); //reset
             this.displayAdvanced = true;
           }
         })
       }
     }
     // set the selected cats from the URL
     else if(pageInfo.operator_category.term_id != pageInfo.operator_listing_type.term_id) {//onload
       if(pageInfo.operator_category.parent  !== pageInfo.operator_listing_type.term_id) {//onload. Subcategories selected
         if(this.postType == 'deal'){
           this.selectedCategory = pageInfo.operator_category.term_id;
       //     this.selectedCategory.push(pageInfo.operator_category.term_id);
           this.displayAdvanced = false;

         } else {
           this.selectedCategory = pageInfo.operator_category.parent;
           this.selectedSubCategories.push( pageInfo.operator_category.term_id); //reset
           
           this.displayAdvanced = true;
         }

       }else{
       //   if(this.postType == 'deal')
       //     this.selectedCategory = this.selectedCategory.push(pageInfo.operator_category.term_id);
       //   else
           this.selectedCategory = pageInfo.operator_category.term_id;

       }
     }

     window.onpopstate = function(event) {
       console.warn("location: " + document.location + ", state: " + JSON.stringify(event.state));
     };

     this.getPosts();
   },
   methods: {
     getOperators () { //OLD AW BASED VERSION
       let self = this
       this.pageNumber = 1
       //let subcategories = ''
       this.restParamsString = ''
       this.isLoading = true;

       // Get keywords
       if (this.keywords !== '')
         this.restParamsString = '&search=' + this.keywords

       // Generate location query string
       if (this.selectedLocation !== '')
         this.restParamsString += '&operator_location=' + this.selectedLocation

       this.restParamsString += `&operator_type=${this.operatorListingType.slug}`;

       if (this.operator_category.parent != 0 && pageInfo.operator_listing_type.term_id != this.operator_category.term_id )
           this.restParamsString += '&operator_category=' + this.operator_category.term_id


       const itemsPerPage = this.isMapView ? 999 : this.itemsPerPage;


       axios //.get('/wp-json/wp/v2/operator?per_page=' + itemsPerPage + this.restParamsString)
       .get(`${baseURL}${this.postType}?per_page=${itemsPerPage}${this.restParamsString}`, {})

         .then(function (response) {
           self.operators = response.data
           self.operatorLength = self.operators.length
           self.pagesTotal = parseInt(response.headers['x-wp-totalpages'])
           self.isLoading = false
           console.warn(response.headers['x-wp-totalpages'])


           self.operators.forEach(item => {
               //item["description"] = ""; //already set in api to the cpt
               if(item.operator_data.is_proud_member){
                   item["url"] = item.link;
               } else {
                   // non member don't have full pages ie a link
                   item["fimg"] = ''; // they don't have custom images (incase there is already one set)
               }
           });

           if(self.isMapView)
             EventBus.$emit('update-operator-map')


           if (response.data.length < 1)
             self.noResults = true

         })

     },
     getMoreOperators () { //OLD AW BASED VERSION
       this.pageNumber++

       let self = this
       this.isLoading = true
       //axios.get('/wp-json/wp/v2/operator?per_page=' + this.itemsPerPage + '&page=' + this.pageNumber + this.restParamsString)
       axios.get(`${baseURL}${this.postType}?per_page=${this.itemsPerPage}&page=${this.pageNumber}` + this.restParamsString)

         .then(function (response) {


           response.data.forEach(item => {
             //item["description"] = ""; //already set in api to the cpt
               if(item.operator_data.is_proud_member){
                   item["url"] = item.link;
               } else {
                   // non member don't have full pages ie a link
                   item["fimg"] = ''; // they don't have custom images (incase there is already one set)
               }
           });

           self.operators = self.operators.concat(response.data)
           self.operatorLength = self.operators.length
           self.isLoading = false

         })
     },
     getLocations(){

       let _this = this;

       axios
       .get(baseURL + `operator_location?post_type=${_this.postType}&per_page=100`, {})
       .then(function(response) {
         response.data.forEach(item => {
           _this.locations.push({
             value: item["id"],
             label: item["name"],
             slug: item["slug"]
           });
         });
       })
       .catch(function(error) {
         console.error(error);
       });

     },
     getCategories(){
       let _this = this;

       let catQuery = `${pageInfo.site_url}/wp-json/wisdom-operators/v1/subcategories/${pageInfo.operator_listing_type.term_id}?hide_empty=1`
       
       if(this.wisdom_operatorfeedblock)
         catQuery = `${pageInfo.site_url}/wp-json/wp/v2/operator_category?hide_empty=1&per_page=100`
       else if(this.operatorListingType.taxonomy != 'operator_category')
         catQuery = `${pageInfo.site_url}/wp-json/wp/v2/${this.operatorListingType.taxonomy}?hide_empty=1&per_page=100`;

       axios.get(catQuery, {})
       .then(function(response) {
         response.data.forEach(item => {
           _this.categories.push({
             value: item["id"] ? item["id"] : item["term_id"],
             label: item["name"],
             slug: item["slug"],
             term_id: item["id"] ? item["id"] : item["term_id"],
             parent: item["parent"]
           });
         });
       })
       .catch(function(error) {
         console.error(error);
       });
     },
     getFacilities(){
       let _this = this;

       let catQuery = `${pageInfo.site_url}/wp-json/wp/v2/operator_facilities?per_page=100`

       axios.get(catQuery, {})
       .then(function(response) {
         response.data.forEach(item => {
           _this.facilities.push({
             value: item["id"] ? item["id"] : item["term_id"],
             label: item["name"],
             slug: item["slug"],
             term_id: item["id"] ? item["id"] : item["term_id"],
           });
         });
       })
       .catch(function(error) {
         console.error(error);
       });
     },
     /* not needed, this was used just for the markers, but we are using this enpoint for the list data now */
     /*
     getMapMarkers(){
       let _this = this;
       axios
       .get(`${pageInfo.site_url}/wp-json/wisdom-operators/v1/operators?exclude_nocoords=1&post_type=members${_this.queryString}`, {})
       .then(function(response) {
         console.warn(response.data);
         _this.mapOperators = response.data;
       })
       .catch(function(error) {
         console.error(error);
       });
     },
     */
     getSelectedCategoryHeading() {
       const category = this.categories.find(category => category.slug === this.selectedCategory)

       if(category)
         return category.heading

       return 'All'
     },
     updateCategory($category) {
       console.warn($category);
       if (!this.displaySearchBtn) {
         //this.category = $category; // automatically update the list
         this.selectedCategory = $category;

         if(!$category && pageInfo.operator_category.name == 'Wine Directory')
           this.selectedCategory = pageInfo.operator_category.term_id;

         this.selectedSubCategories = []; //reset
         this.selectedPaginationItem = false; //reset
         this.displayAdvanced = true;
         this.getPosts();
       } else {
         this.filterData["category"] = $category; // save it for when user presses submit
       }
       this.updateUrl();
     },
     updateFacility($facility) {
       if (!this.displaySearchBtn) {
         this.selectedFacility = $facility;
         this.selectedPaginationItem = false; //reset
         this.getPosts();
       } else {
         this.filterData["facility"] = $facility; // save it for when user presses submit
       }
       this.updateUrl();
     },
     updateCategoryArray(category) {  // for multi select category

       if (!this.displaySearchBtn) {
         const catIndex = this.selectedCategory.indexOf(category);
         if(catIndex == -1)
           this.selectedCategory.push(category);
         else
           this.selectedCategory.splice(catIndex, 1);

         //this.selectedSubCategories = []; //reset // no sub cats
         this.selectedPaginationItem = false; //reset

         this.getPosts();
         this.updateUrl();
       } else {
         //this.filterData["category"] = category; // save it for when user presses submit
       }
     },
     updateLocation($location) {
       if (!this.displaySearchBtn) {
         // automatically update the list
         this.selectedLocation = $location;
         this.selectedPaginationItem = false; //reset
         this.displayAdvanced = false;
         this.getPosts();
       } else {
         this.filterData["location"] = $location; // save it for when user presses submit
       }
       this.updateUrl();
     },
     updateSubCategory(cat){
       const catIndex = this.selectedSubCategories.indexOf(cat.term_id);
       if(catIndex == -1)
           this.selectedSubCategories.push(cat.term_id);
       else
         this.selectedSubCategories.splice(catIndex, 1);

       this.selectedPaginationItem = false; //reset

       this.getPosts();
       this.updateUrl();
       //window.history.replaceState({"html":"lili","pageTitle":"response.pageTitle", "selectedCats": this.selectedSubCategories},"", "./lili"+cat.slug);
     },
     updatePaginationItem(item){
       if(this.selectedPaginationItem == item.label) {
         this.selectedPaginationItem = false; //toggle off if clicked on again
         this.pagesTotal = Math.ceil(this.operators.length/this.itemsPerPage);
       } else {
         this.selectedPaginationItem = item.label;
         this.pagesTotal = Math.ceil(item.count/this.itemsPerPage);
       }

       this.pageNumber = 1;

       const operatorsContainer = document.querySelector('.article-list__items, .operator-feed__map-container');
       setTimeout(function(){
         window.scrollTo({top: operatorsContainer.offsetTop-120, behavior: 'smooth'})
         console.log("SCROL NOW")
       }, 100);
     },
     resetFilter() { console.log("reset");
       this.keywords = this.selectedCategory = this.selectedLocation = "";
       this.selectedSubCategories = []; //reset
       this.selectedFacility = ''; //reset
       this.selectedPaginationItem = false; //reset
       this.displayAdvanced = false;

       if(this.postType == 'deal')
         this.selectedCategory = '';

       this.updateUrl();
       this.getPosts();
     },
     updateKeywords($keywords) {
       if (!this.displaySearchBtn) {
         this.keywords = $keywords; // automatically update the list
         this.selectedPaginationItem = false; //reset

         this.debounceKeywords(function() {
           console.log("Time elapsed!!!!! get new data");
           this.getPosts();
         }, 900);

       } else {
         this.filterData["keywords"] = $keywords; // save it for when user presses submit
       }
     },
     toggleMapView() {
       this.isMapView = !this.isMapView
     //if(this.isMapView)
          // EventBus.$emit('update-operator-map'); //lili add
       //this.getOperators();

     },
     updateUrl(){
       let url = `${pageInfo.site_url}/${pageInfo.operator_listing_type.slug}/`;

       if(this.wisdom_operatorfeedblock) {
           if(this.selectedSubCategories.length > 0) {
             this.selectedSubCategories.forEach( (cat, i) => url += `${ i > 0 ? '&' : '?'}cat[]=${this.getCategoryById(cat).slug}`) 
           } else if(this.selectedCategory) {
             const term = this.getCategoryById(this.selectedCategory);
             url = `?cat[]=${term.slug}`;
           }

       } else if(this.selectedCategory) {

       //   if(this.postType == 'deal') { // array of cats (ie no sub cats)
       //     const term = this.getCategoryById(this.selectedCategory[this.selectedCategory.length - 1]);
       //     console.log(`my term = `);
       //     console.log(term);
       //     if(term)
       //       url += term.slug+"/";

       //       //TODO this only adds 1 subcategory t url, what if multiple are selected, maybe we can add additional GET vars


       //   }else{
           const term = this.getCategoryById(this.selectedCategory);
           console.log(`my term = `);
           console.log(term);
           url += term.slug+"/";

           if(this.selectedSubCategories.length > 0) {
             const term = this.getCategoryById(this.selectedSubCategories[this.selectedSubCategories.length-1]);
             console.log(`my term = `);
             console.log(term);
             url += term.slug;

             //TODO this only adds 1 subcategory t url, what if multiple are selected, maybe we can add additional GET vars
           }
       //   }

       }

       console.log('REPLACING URL HERE');
       window.history.replaceState({"html":"lili","selectedCats": this.selectedSubCategories},"", url); // todo, what data if any do we need to keep

     },
     getCategoryById(termId) {
       console.warn('term = '+termId)
        const term =  this.categories.filter(item => {
           return termId == item.term_id
        });

        if(term)
           return term[0];
     },
      getPostsOLD: function(isNewSearch = true) {
       console.warn("GETTINGPOSTS");
       var _this = this;

       this.noResults = false;

       this.queryString = ""; // if there is no category specified, if will get all post regardless of what category
       // if (this.postType === "posts" && pageInfo.news_cat_id)
       //   this.queryString = `&categories=${pageInfo.news_cat_id}`;

       //if (this.category != "") this.queryString = `&categories=${this.category}`;

       if (this.keywords != "") this.queryString += `&search=${this.keywords}`;

       if (this.dateRange && this.dateRange.length > 1) {
         let from = this.dateRange[0] + "T00:00:00.000Z";
         let to = this.dateRange[1] + "T23:59:59.000Z";

         this.queryString += `&after=${from}&before=${to}`;
       }

       if (this.selectedLocation !== '') this.queryString += `&operator_location=${this.selectedLocation}`;

       if(this.operatorListingType.slug != 'see-do')
         this.queryString += `&operator_type=${pageInfo.operator_listing_type.slug}`; // needed for tours & accomodation

       //if (this.operator_category.parent != 0 && pageInfo.operator_listing_type.term_id != this.operator_category.term_id ) this.queryString += `&operator_category=${this.selectedCategory}`

       if (this.selectedSubCategories.length > 0 )
         this.selectedSubCategories.forEach(item => { this.queryString +=  `&operator_category[]=${item}`});
       else if (this.selectedCategory != "" )
         this.queryString += `&operator_category[]=${this.selectedCategory}`;


       console.warn(`query string = ${this.queryString}`);

       if (isNewSearch){
         this.pageNumber = 1;//reset
         this.isNewSearch = true;
       } else {
         this.pageNumber++; // ie we are 'loading more'
         this.isNewSearch = false;
       }

       this.getPostsRequest(baseURL + _this.postType + `?per_page=${this.itemsPerPage}&page=${this.pageNumber}${this.queryString}`, isNewSearch)
       .then(function(response){
         if(response) { // check incase request was previously cancelled is wont produce results
           console.warn(response);

           let newPosts = response.data;

           newPosts.forEach(item => {
             //item["description"] = ""; //already set in api to the cpt

             if(item.operator_data.is_proud_member){
                 item["url"] = item.link;
             } else {
                 // non member don't have full pages ie a link
                 item["fimg"] = ''; // they don't have custom images (incase there is already one set)
             }
           });

           if (isNewSearch)
             _this.operators = newPosts; // replace all old posts with new results
           else
             _this.operators.push(...newPosts); // we are 'loading more': append new results

           // if(newPosts.length == 0)
           //   this.loadMessage = "No data found"; // for when there is actually no data
           // else
           //   this.loadMessage = ""
           _this.isLoading = false;
           _this.pagesTotal = response.headers["x-wp-totalpages"];

           if(self.isMapView)
             EventBus.$emit('update-operator-map')

           if (response.data.length < 1)
              _this.noResults = true
         }
       });
       /*

this.getPostsRequest( baseURL + 'members' + `?per_page=5`).then(function(results){
         if(results) { // incase request was cancelled
             console.warn(results);
         }
       });
   console.warn('waiting for response');
       //this.keywords = this.category = this.dateRange = "";
       //this.getPosts();

       */
     },
     getPosts: function(isNewSearch = true) {
       console.warn("GETTINGPOSTS");
       var _this = this;

       this.noResults = false;

       this.queryString = ""; // if there is no category specified, if will get all post regardless of what category
       // if (this.postType === "posts" && pageInfo.news_cat_id)
       //   this.queryString = `&categories=${pageInfo.news_cat_id}`;

       //if (this.category != "") this.queryString = `&categories=${this.category}`;

       if(this.wisdom_operatorfeedblock)
         this.queryString += `&operatorfeedblock=${this.wisdom_operatorfeedblock}`

       if (this.keywords != "") this.queryString += `&search=${this.keywords}`;

       if (this.dateRange && this.dateRange.length > 1) {
         let from = this.dateRange[0] + "T00:00:00.000Z";
         let to = this.dateRange[1] + "T23:59:59.000Z";

         this.queryString += `&after=${from}&before=${to}`;
       }

       if (this.selectedLocation !== '') this.queryString += `&operator_location=${this.selectedLocation}`;
       if (this.selectedFacility !== '') this.queryString += `&operator_facilities=${this.getSelectedFacility}`;

       //if(this.operatorListingType.slug != 'see-do')
       if(!this.wisdom_operatorfeedblock && this.operatorListingType.slug != 'see-do')
         this.queryString += `&operator_type=${pageInfo.operator_listing_type.slug}`; // needed for tours & accomodation

       //if (this.operator_category.parent != 0 && pageInfo.operator_listing_type.term_id != this.operator_category.term_id ) this.queryString += `&operator_category=${this.selectedCategory}`

       if (this.selectedSubCategories.length > 0 )
         this.selectedSubCategories.forEach(item => { this.queryString +=  `&category[]=${item}`});
       // else if (this.postType == 'deal' && this.selectedCategory.length > 0 )
       //   this.selectedCategory.forEach(item => { this.queryString +=  `&category[]=${item}`});
       else if (this.selectedCategory != "" )
         this.queryString += `&category[]=${this.selectedCategory}`;
       else if(pageInfo.operator_listing_type.slug == 'wine-directory')
         this.queryString +=  `&category[]=${pageInfo.operator_listing_type.term_id}`;

       // only display those set to 'see & do' if we are on the see & do page
       if(this.operatorListingType.slug == 'see-do' && this.selectedSubCategories.length === 0 && this.selectedCategory == ""){
           this.queryString += `&category[]=${this.operatorListingType.term_id}`;
       }

       this.queryString += `&category_taxonomy=${this.operatorListingType.taxonomy}`;
       this.queryString += `&orderby=title&order=asc`;

       console.warn(`query string = ${this.queryString}`);

       if (isNewSearch){
         this.pageNumber = 1;//reset
         this.isNewSearch = true;
       } else {
         this.pageNumber++; // ie we are 'loading more'
         this.isNewSearch = false;
       }

       //this.getPostsRequest(baseURL + _this.postType + `?per_page=${this.itemsPerPage}&page=${this.pageNumber}${this.queryString}`, isNewSearch)
       this.getPostsRequest(`${pageInfo.site_url}/wp-json/wisdom-operators/v1/operators?exclude_nocoords=0&post_type=${this.postType}${_this.queryString}`, {})

       .then(function(response){
         if(response) { // check incase request was previously cancelled is wont produce results
           console.warn(response);

           let newPosts = response.data;

           newPosts.forEach(item => {
             if(_this.postType == 'deal') // dont' display any of the operator contact detail on the Deals list
               item.operator_data["phone"] = item.operator_data["address"] = item.operator_data["email"] = item.operator_data["website"] = false;

             if(!item.operator_data.display_page & _this.postType != 'deal' ){
               // non member don't have full pages ie a link
               item["fimg"] = false; // they don't have custom images (incase there is already one set)
               item["url"] = false;
             }
           });

           if (isNewSearch)
             _this.operators = newPosts; // replace all old posts with new results
           else
             _this.operators.push(...newPosts); // we are 'loading more': append new results

           // if(newPosts.length == 0)
           //   this.loadMessage = "No data found"; // for when there is actually no data
           // else
           //   this.loadMessage = ""
           //_this.isLoading = false;
           //_this.pagesTotal = response.headers["x-wp-totalpages"];
           _this.pagesTotal = Math.ceil(response.data.length/_this.itemsPerPage);

           //if(_this.isMapView)
             EventBus.$emit('update-operator-map')

           if (response.data.length < 1)
              _this.noResults = true
         }
       });
     },
     loadMorePosts() {
       this.getPosts(false);
     },
     displayMorePosts() {
       this.pageNumber++;
     },
     subCategoriesClass(id, arrayName = 'selectedSubCategories'){
       let cssClass=[];

       cssClass.push("subcategory-btn");

       if(this[arrayName].includes(id))
           cssClass.push("is-selected");

       return cssClass;
     },
     appClasses() {
       let cssClass=[];

       cssClass.push("article-list");

       if(this.isLoading)
           cssClass.push("is-loading");

       if(this.isLoading && this.isNewSearch)
           cssClass.push("is-new-search");

       return cssClass;
     },
   },
   computed: {
     mainCategories() { // first level of categories (ie the ones under see-do, tours, accomm). Don't ever change.

       if(this.selectedCategory == 299) //temporary. For SUvivl pack - hide all other categories. requested by mark
         return this.categories.filter(item => item["term_id"] == 299);

       if(this.postType == 'deal')
         return this.categories;

       if(this.wisdom_operatorfeedblock) {
           return this.categories.filter(item => {
               if (item.parent == 18 || item.term_id == 19 || item.term_id == 20)
                   return true;
           });
       }

       return this.categories.filter(item => {
         if (pageInfo.operator_listing_type.term_id == item.parent)
           return true;
       });
     },
     mainFacilities() {
       return this.facilities
     },
     getSelectedFacility() {
       return this.selectedFacility
     },
     subCategories() { // second level of categories, ie children of the mainCategories. Changes when selectedCategory (in MainCategories) changes
       let subCat = this.categories.filter(item => {
         if (this.selectedCategory && this.selectedCategory == item.parent)
           // display all (if no category selected)
           return true;
       });

       //sort a-z
       return subCat.sort((a,b) => {
         if(a.label > b.label) {return 1}
         if(a.label < b.label) {return -1}
         return 0
       })
     },
     filteredData() {
       let data = this.operators.filter(item => {
         if(!this.selectedPaginationItem)
           return true;

         if(this.selectedPaginationItem == item.paginationKey)
           return true;
       });

       if(this.selectedPaginationItem) { // if pagination is selected, sort by alpha
         return data.sort( (a, b) => {
           if (a.title.rendered == b.title.rendered)
               return 0;
           else
               return a.title.rendered < b.title.rendered ? -1 : 1;
         });
       }

       return data.slice(0, this.pageNumber * this.itemsPerPage)
     },
     mapData() { // Same as filteredData but returns ALL
       return this.operators.filter(item => {
         if(!this.selectedPaginationItem)
           return true;

         if(this.selectedPaginationItem == item.paginationKey)
           return true;

       });
     },
     filteredDataAllWithMarkers () {
       return this.mapData.filter( (item) => {
         if(item.operator_data.latitude)
           return true;
         }
       );
     },
   //   hasMorePages() {
   //     return this.pagesTotal >= this.pageNumber
   //   }
   }
 }


 /*
 window.addEventListener('popstate', function(e) {
   console.log("pop state");
 });
 */





// WEBPACK FOOTER //
// ./scripts/vue/OperatorFeed.vue